export function renderTerminalTopBar(): string {
    return `
      <header class="terminal-topbar">
        <div class="terminal-topbar__brand">INDIEYE TERMINAL</div>
        <form id="terminal-command-form" class="terminal-command" autocomplete="off">
          <input id="terminal-command-input" class="terminal-command__input" type="text" placeholder="SYMBOL RELIANCE GO | NEWS | BREADTH | CHAIN" aria-label="Terminal command bar" />
        </form>
        <div class="terminal-topbar__status">
          <span id="terminal-command-status" class="terminal-pill">READY</span>
          <span id="terminal-market-state" class="terminal-pill">MARKET</span>
          <span id="terminal-api-health" class="terminal-pill terminal-pill--api">API --</span>
          <span id="terminal-clock" class="terminal-pill terminal-pill--mono">--:--</span>
          <button id="terminal-theme-toggle" class="terminal-topbar__btn" type="button" title="Toggle theme">THEME</button>
          <button id="terminal-rightrail-toggle" class="terminal-topbar__btn" type="button" title="Toggle right rail">RAIL</button>
        </div>
      </header>
    `;
}
